import { useState } from 'react'
import { useRouter } from 'next/router'
import { enqueueSnackbar } from 'notistack'
import { useGqlViewerExamReserveInformationLazyQuery } from 'generated/graphql'
import { formatPhoneNumber } from '../../modules'
import { TPreReservationFormValues } from '../constants/form'

type TUseGetFormInitialValuesReturns = {
  isUpdateStatus: boolean
  disabled: boolean
  fetchInitialData: () => Promise<TPreReservationFormValues>
}

type TUseGetFormInitialValuesFnParams = {
  companyId: string
  termId: string
}

const useGetFormInitialValues = ({
  companyId,
  termId,
}: TUseGetFormInitialValuesFnParams): TUseGetFormInitialValuesReturns => {
  const router = useRouter()
  const { query } = router

  const hash = query.tab
    ? query.tab === 'full-reservation'
      ? 'section1'
      : 'section2'
    : undefined

  const [isUpdateStatus, setIsUpdateStatus] = useState<boolean>(false)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [viewerExamReservation] = useGqlViewerExamReserveInformationLazyQuery({
    variables: {
      input: {
        companyId,
        termId,
      },
    },
  })

  const fetchInitialData = async (): Promise<TPreReservationFormValues> => {
    const { data } = await viewerExamReservation({
      onError: (error) => {
        enqueueSnackbar(error.message)
        router.replace({
          query: {
            ...query,
            testId: '',
          },
          hash,
        })
      },
      onCompleted: (data) => {
        setIsUpdateStatus(!!data?.viewerExamReserveInformation)
        setDisabled(!!data?.currentUser?.phoneNumber)
        router.replace(
          {
            query: {
              ...query,
              testId: data.viewerExamReserveInformation?.examTest.id,
            },
            hash,
          },
          undefined,
          {
            scroll: false,
          },
        )
      },
    })
    const defaultValues = {
      companyId,
      termId,
      subsidiaryId:
        data?.viewerExamReserveInformation?.examSubsidiary?.id || '',
      departmentId:
        data?.viewerExamReserveInformation?.examDepartment?.id || '',
      jobId: data?.viewerExamReserveInformation?.examJob?.id || '',
      testId: data?.viewerExamReserveInformation?.examTest?.id || '',
      phoneNumber: formatPhoneNumber(data?.currentUser?.phoneNumber),
      hasAgreedToPrivacy:
        data?.viewerExamReserveInformation?.hasAgreedToPrivacy || false,
    }
    return defaultValues
  }

  return {
    isUpdateStatus,
    disabled,
    fetchInitialData,
  }
}

export default useGetFormInitialValues
